import { render, staticRenderFns } from "./AddFileFormModal.vue?vue&type=template&id=30268403"
import script from "./AddFileFormModal.vue?vue&type=script&lang=js"
export * from "./AddFileFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports